module.exports = __webpack_public_path__ + "static/media/audi.cd1fed3a.png";